import React, { useState } from "react";
import { Modal, Button } from "antd";

const PODModal = ({ isPodVisible, setIsPodVisible, imgUrls }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const prevImage = () => {
    setCurrentIndex((prev) => (prev === 0 ? imgUrls.length - 1 : prev - 1));
  };

  const nextImage = () => {
    setCurrentIndex((prev) => (prev === imgUrls.length - 1 ? 0 : prev + 1));
  };

  return (
    <Modal
      title="Proof of Delivery"
      visible={isPodVisible}
      onOk={() => setIsPodVisible(false)}
      onCancel={() => setIsPodVisible(false)}
      footer={null} // remove default buttons
      width={600} // optional: adjust modal width
    >
      {imgUrls.length > 0 && (
        <div style={{ textAlign: "center" }}>
          <img
            src={imgUrls[currentIndex]}
            alt={`Preview ${currentIndex + 1}`}
            style={{ width: "100%", maxHeight: "60vh", objectFit: "contain" }}
          />
          <div style={{ marginTop: 10 }}>
            <Button onClick={prevImage} style={{ marginRight: 10 }}>
              Prev
            </Button>
            <span>
              {currentIndex + 1} / {imgUrls.length}
            </span>
            <Button onClick={nextImage} style={{ marginLeft: 10 }}>
              Next
            </Button>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default PODModal;